import Login from '@/pages/admin/Login';
import Contacts from '@/pages/admin/Contacts';

const meta = { auth: true, admin: true };

const adminRoutes = [
  {
    path: '/admin/login',
    component: Login,
    name: 'admin-login',
  },
  {
    path: '/admin',
    component: Contacts,
    name: 'admin-contacts',
    meta,
  },
  {
    path: '/admin/customers',
    component: () => import(/* webpackChunckName: "admin" */ '../pages/admin/Customers'),
    name: 'admin-customers',
    meta,
  },
  {
    path: '/admin/referrals-history',
    component: () => import(/* webpackChunckName: "admin" */ '../pages/admin/ReferralsHistory'),
    name: 'admin-referral-history',
    meta,
  },
  {
    path: '/admin/referrals-pending-payouts',
    component: () =>
      import(/* webpackChunckName: "admin" */ '../pages/admin/ReferralsPendingPayouts'),
    name: 'admin-pending-payouts',
    meta,
  },
  {
    path: '/admin/referrals-general-pending-payouts',
    component: () =>
      import(/* webpackChunckName: "admin" */ '../pages/admin/ReferralsGeneralPendingPayouts'),
    name: 'admin-pending-payouts-general',
    meta,
  },
  {
    path: '/admin/training-schedule-us/:location',
    component: () => import(/* webpackChunckName: "admin" */ '../pages/admin/TrainingSchedule'),
    name: 'admin-training-schedule-us',
    meta,
  },
  {
    path: '/admin/training-schedule-eu/:location',
    component: () => import(/* webpackChunckName: "admin" */ '../pages/admin/TrainingScheduleEU'),
    name: 'admin-training-schedule-eu',
    meta,
  },
  {
    path: '/admin/pre-training',
    component: () => import(/* webpackChunckName: "admin" */ '../pages/admin/PreTraining'),
    name: 'admin-pretraining',
    meta,
    children: [
      {
        path: 'view/:id',
        component: () => import(/* webpackChunckName: "admin" */ '../pages/admin/PreTrainingView'),
      },
      {
        path: 'edit/:id',
        component: () => import(/* webpackChunckName: "admin" */ '../pages/admin/PreTrainingEdit'),
      },
    ],
  },
  {
    path: '/admin/training-videos',
    component: () => import(/* webpackChunckName: "admin" */ '../pages/admin/TrainingVideos'),
    name: 'admin-training-videos',
    meta,
    children: [
      {
        path: 'view/:id',
        component: () =>
          import(/* webpackChunckName: "admin" */ '../pages/admin/TrainingVideosView'),
      },
      {
        path: 'edit/:id',
        component: () =>
          import(/* webpackChunckName: "admin" */ '../pages/admin/TrainingVideosEdit'),
      },
    ],
  },
  {
    path: '/admin/post-training-videos',
    component: () => import(/* webpackChunckName: "admin" */ '../pages/admin/PostTrainingVideos'),
    name: 'admin-post-training-videos',
    meta,
    children: [
      {
        path: 'view/:id',
        component: () =>
          import(/* webpackChunckName: "admin" */ '../pages/admin/PostTrainingVideosView'),
      },
      {
        path: 'edit/:id',
        component: () =>
          import(/* webpackChunckName: "admin" */ '../pages/admin/PostTrainingVideosEdit'),
      },
    ],
  },
  {
    path: '/admin/products',
    component: () => import(/* webpackChunckName: "admin" */ '../pages/admin/Products'),
    name: 'admin-products',
    meta,
  },
  {
    path: '/admin/accessories',
    component: () => import(/* webpackChunckName: "admin" */ '../pages/admin/Accessories'),
    name: 'admin-accessories',
    meta,
  },
  {
    path: '/admin/account',
    name: 'admin-account-admin',
    component: () => import(/* webpackChunckName: "admin" */ '../pages/admin/Account'),
    meta,
  },
  {
    path: '/admin/payout-tags',
    name: 'admin-payout-tags',
    component: () => import(/* webpackChunckName: "admin" */ '../pages/admin/PayoutTags'),
    meta,
  },
  {
    path: '/admin/notifications',
    name: 'admin-notifications',
    component: () => import(/* webpackChunckName: "admin" */ '../pages/admin/Notifications'),
    meta,
  },
  {
    path: '/admin/sales-reps',
    name: 'admin-sales-reps',
    component: () => import(/* webpackChunckName: "admin" */ '../pages/admin/SalesReps'),
    meta,
  },
];

export default adminRoutes;
